import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  action: "insert",
  // type: null,
  // cat: null,
  id: null,
  title: null,
  startDate: null,
  dueDate: null,
  notif: null,
  notifDate: null,
  admin: null,
  adminName: null,
  trainee: null,
};

export const TrackerSlice = createSlice({
  name: "TrainingTracker",
  initialState,
  reducers: {
    init: (state, action) => {
      return {
        ...initialState,
        admin: action.payload.admin,
        adminName: action.payload.adminName,
      };
    },

    updateAll: (state, action) => {
      return {
        ...action.payload,
      };
    },

    updateType: (state, action) => {
      return {
        ...state,
        type: action.payload.type,
      };
    },
    updateCat: (state, action) => {
      return {
        ...state,
        cat: action.payload.cat,
      };
    },
    updateTitle: (state, action) => {
      return {
        ...state,
        title: action.payload.title,
      };
    },
    updateStartDate: (state, action) => {
      return {
        ...state,
        startDate: action.payload.startDate,
      };
    },
    updateDueDate: (state, action) => {
      return {
        ...state,
        dueDate: action.payload.dueDate,
      };
    },

    updateNotification: (state, action) => {
      const notification = action.payload.notif;
      let notificationDate = null;
      const dueDate = new Date(state.dueDate);

      if (notification > 0) {
        notificationDate = new Date(
          dueDate.getTime() - notification * 60 * 1000
        ).toISOString();
      } else if (notification == 0) {
        notificationDate = state.dueDate;
      }

      return {
        ...state,
        notif: notification,
        notifDate: notificationDate ? notificationDate : state.notifDate,
      };
    },

    updateNotificationDate: (state, action) => {
      return {
        ...state,
        notifDate: action.payload.notifDate,
      };
    },

    // updateTrainee: (state, action) => {
    //   return {
    //     ...state,
    //     trainee: action.payload.trainee,
    //   };
    // },
  },
});

export const {
  init,
  updateAll,
  updateType,
  updateCat,
  updateTitle,
  updateStartDate,
  updateDueDate,
  updateNotification,
  updateNotificationDate,
  // updateTrainee,
} = TrackerSlice.actions;

export default TrackerSlice.reducer;
